const esTranslation = {
  // Común
  app_name: 'Adivino de Fortuna',
  home: 'Inicio',
  login: 'Iniciar Sesión',
  back: 'Atrás',
  next: 'Siguiente',
  submit: 'Enviar',
  cancel: 'Cancelar',
  required: 'Obligatorio',
  cat_saju: 'K-ホーム',
  // Página Principal
  fortune_categories: 'Categorías de Fortuna',
  best_items: 'Mejores Productos',
  all_categories: 'Todas las Categorías',
  favorites: 'Favoritos',
  history: 'Historial',
  my_page: 'Mi Página',
  tarot_new: '¡Nuevo Tarot Disponible!',
  tarot_desc: 'Lectura auténtica de tarot incluyendo cartas invertidas',
  
  // Categorías
  cat_reunion: 'Reencuentro',
  cat_marriage: 'Matrimonio',
  cat_love: 'Amor',
  cat_compatibility: 'Compatibilidad',
  cat_newyear: 'Año Nuevo',
  cat_career: 'Carrera',
  cat_trial: 'Lectura de Prueba',
  cat_free: 'Prueba Gratuita',
  cat_wealth: 'Riqueza',
  cat_tarot: 'Tarot',
  cat_tarot_love: 'Tarot de Amor',
  cat_tarot_future: 'Tarot del Futuro',
  cat_tarot_career: 'Tarot de Carrera',
  best_items_saju: 'Mejores Productos',
  best_items_tarot: 'Mejores Productos de Tarot',
  
  // Títulos de Productos
  product_reunion_title: '¿Puedo volver a encontrarme con esa persona?',
  product_compatibility_title: '¿Citas, matrimonio y compatibilidad profunda?',
  product_marriage_title: '¿Cuándo me casaré?',
  product_love_title: '¿Cómo es mi fortuna en el amor?',
  product_newyear_title: '¿Qué traerá el año nuevo?',
  product_career_title: '¿Cómo es mi fortuna en la carrera?',
  product_wealth_title: '¿Cómo es mi fortuna en la riqueza?',
  product_tarot_love_title: 'Lectura de tarot para tu amor',
  product_tarot_future_title: 'Lectura de tarot para tu futuro',
  product_tarot_career_title: 'Lectura de tarot para tu carrera',
  
  // Página de Detalles del Producto
  product_detail_title: 'Detalles del Producto - Adivino de Fortuna',
  original_price: 'Precio Original',
  discount_rate: 'Descuento',
  final_price: 'Precio',
  buy_now: 'Comprar Ahora',
  product_details: 'Detalles del Producto',
  reviews: 'Reseñas',
  product_includes: 'Esta lectura incluye:',
  product_not_found: 'Producto no encontrado',
  all_rights_reserved: 'Todos los derechos reservados',
  
  // Descripciones de Productos
  product_reunion_desc: 'A través de tu carta astral, examinaremos la posibilidad de reencuentro con esa persona. Analizaremos cuándo y cómo podrías reunirte con tu ex-pareja, viejo amigo o alguien que no puedes olvidar.',
  product_marriage_desc: 'Analizaremos tu tiempo de matrimonio y potencial pareja a través de tu carta astral. Te diremos cuándo podrías casarte, las características de tu cónyuge y la naturaleza de tu vida matrimonial.',
  product_love_desc: 'Analizaremos tu fortuna amorosa y relaciones a través de tu carta astral. Te contaremos sobre tu relación actual, cuándo podrían llegar nuevas relaciones y tu tipo de pareja ideal.',
  product_compatibility_desc: 'Analizaremos tu compatibilidad con esa persona a través de ambas cartas astrales. Te hablaremos sobre tu compatibilidad amorosa, compatibilidad matrimonial y compatibilidad oculta.',
  product_newyear_desc: 'Analizaremos tu fortuna general para 2025 a través de tu carta astral. Te contaremos sobre tu fortuna financiera, fortuna de salud, fortuna de negocios y momentos importantes.',
  product_career_desc: 'Analizaremos tu aptitud profesional, tiempos de éxito y períodos favorables para promoción o cambio de trabajo a través de tu carta astral.',
  product_wealth_desc: 'Analizaremos tu fortuna de riqueza a través de tu carta astral. Te diremos cuándo podría aumentar tu ingreso, cuándo ser cuidadoso con los gastos, y momentos y áreas favorables para inversión.',
  
  // Página de Entrada de Nacimiento
  birth_info_title: 'Ingresa Tu Información de Nacimiento',
  birth_info_desc: 'Por favor ingresa tu fecha y hora de nacimiento para una lectura precisa.',
  birth_date: 'Fecha de Nacimiento',
  birth_year: 'Año',
  birth_month: 'Mes',
  birth_day: 'Día',
  birth_time: 'Hora de Nacimiento',
  unknown_time: 'Hora Desconocida',
  partner_info: 'Información de la Pareja',
  partner_birth_date: 'Fecha de Nacimiento de la Pareja',
  
  // Página de Entrada de Comentarios
  concern_title: 'Evento Especial',
  concern_desc: 'Por favor comparte tu preocupación o pregunta (opcional)',
  concern_placeholder: 'Ingresa tu preocupación o pregunta aquí...',
  char_count: 'caracteres',
  
  // Página de Pago
  payment_title: 'Pago',
  payment_desc: '¡Solo 19,900 won!',
  product_name: 'Nombre del Producto',
  product_price: 'Precio del Producto',
  coupon: 'Cupón',
  total_payment: 'Pago Total',
  max_discount: 'Descuento máximo aplicado',
  coupon_change: 'Cambiar Cupón',
  payment_method: 'Método de Pago',
  card_payment: 'Tarjeta de Crédito',
  bank_transfer: 'Transferencia Bancaria',
  agree_terms: 'Estoy de acuerdo con los términos de servicio',
  proceed_payment: 'Pagar Ahora',
  
  // Página de Resultados
  result_title: 'Tu Resultado de Fortuna',
  result_desc: 'Basado en tu información de nacimiento, aquí está tu lectura de fortuna.',
  
  // Página de Inicio de Sesión
  login_with_google: 'Iniciar Sesión con Google',
  login_desc: 'Inicia sesión para guardar tus lecturas y obtener recomendaciones personalizadas.',
  
  // Mensajes de Validación
  validate_birth_date: 'Por favor ingresa tu fecha de nacimiento completa.',
  validate_birth_time: 'Por favor ingresa la hora de nacimiento o marca "Hora Desconocida".',
  validate_partner_birth: 'Por favor ingresa la fecha de nacimiento completa de tu pareja.'
};

export default esTranslation;
